import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox, Form } from 'semantic-ui-react'

import Container from './GroupPermissionContainer'

import * as styles from './styles'

const GroupPermission = ({ checked, onSelect, permission }) => {
  const { description, name } = permission

  return (
    <Form.Group onClick={onSelect} grouped>
      <Checkbox label={name} checked={checked} />
      <br />
      <label style={styles.description}>{description}</label>
    </Form.Group>
  )
}

GroupPermission.propTypes = {
  checked: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  permission: PropTypes.object.isRequired,
}

export default Container(GroupPermission)
